import {isEmptyValue} from './validator.js'

export const capitalizeFirstLetter = ([first, ...rest]) => {
  return [ first.toUpperCase(), ...rest ].join('')
}

/** TLV 18/03/2020
* @fn createForeignIban
* @brief Fonction permettant de créer un "faux" iban en base selon le codage proposé pour chaque pays
* @param zone est l'objet json correspondant dans le fichiers bankAccounts.js dans l'engine
*/
export const createForeignIban = (zone) => {
  let firstBankData = zone.values[zone.accountLabel[0]]
  let secondBankData = zone.values[zone.accountLabel[1]] != null ? zone.values[zone.accountLabel[1]] : ''
  if (isEmptyValue(firstBankData) || (isEmptyValue(secondBankData) && zone.accountNumberField >= 2)) {
    return ''
  } else {
    let zoneMatchings = {
      'EUR': firstBankData,
      'GBP': 'GB00XXXX' + firstBankData.padStart(6, '0') + secondBankData.padStart(8, '0'),
      'USD': 'US00XXXXXXXXX' + firstBankData.padStart(9, '0'),
      'AUD': 'AU00XXXXXXXXXXXX' + firstBankData.padStart(6, '0')
    }
    return zoneMatchings[zone.label]
  }
}

// Retour temporaire de ces fonctions inutiles sur long terme, le temps de finir les multidevises
export const createIbanUK = (sort, account) => {
  return 'GB00XXXX' + sort.padStart(6, '0') + account.padStart(8, '0')
}

/** TLV 18/03/2020
* @fn extractForeignIban
* @brief Fonction permettant de récupérer les données bancaires correspondantes à partir du "faux IBAN" stocké en base
* @param zone est l'abréviation de la zone géographique (EU, UK, etc)
* @param iban est la chaîne de caractère stockée en base regroupant ces données bancaires
*/
export const extractForeignIban = (iban, zone) => {
  let zoneMatchings = {
    'EUR': {
      iban: {
        labelId: 'common.ibn',
        value: iban,
        hiddenValue: iban.slice(-4).padStart(iban.length, 'X')
      }
    },
    'GBP': {
      sortCode: {
        labelId: 'common.srt_code',
        value: iban.substring(8, 14),
        hiddenValue: 'XX-XX-' + iban.substring(12, 14)
      },
      accountNumber: {
        labelId: 'common.act_nbr',
        value: iban.substring(14, 22),
        hiddenValue: 'XXXX' + iban.substring(18, 22)
      }
    },
    'USD': {
      aba: {
        labelId: 'common.aba',
        value: iban.substring(13, 22),
        hiddenValue: 'XXXXXX' + iban.substring(19, 22)
      }
    },
    'AUD': {
      bsb: {
        labelId: 'common.bsb',
        value: iban.substring(16, 22),
        hiddenValue: 'XXXX' + iban.substring(20, 22)
      }
    }
  }
  return zoneMatchings[zone]
}

/** TBR 14/05/2023
* @fn formatDateTime
* @brief Fonction permettant de récupérer la datetime au format iso à partir de la date d'un input datetime-local
* @param dateString est la date au format YYYY-MM-DDTHH:mm
*/
export const formatDateTime = (dateString) => {
  /*let time = moment().format('HH:mm:ss.SSSZ')
  let tomorrow = moment(date).format('YYYY-MM-DD')
  let datetime = tomorrow + 'T' +  time*/
  let isoDateTimeWithTimezone = ''
  if (dateString.length > 0) {
    dateString = dateString + ':00.000'
    const dateParts = dateString.split('T')
    const date = dateParts[0]
    let time = dateParts[1]
    const milliseconds = time.split('.')[1]
    time = time.split('.')[0]
    const [year, month, day] = date.split('-')
    const [hour, minutes, seconds] = time.split(':')
    const isoDate = `${year}-${padZero(month)}-${padZero(day)}T${padZero(hour)}:${padZero(minutes)}:${padZero(seconds)}.${padZero(milliseconds)}`
    const timezoneOffset = new Date().getTimezoneOffset()
    const offsetHours = Math.floor(Math.abs(timezoneOffset) / 60)
    const offsetMinutes = Math.abs(timezoneOffset) % 60
    const offsetSign = timezoneOffset < 0 ? '+' : '-'
    isoDateTimeWithTimezone = `${isoDate}${offsetSign}${padZero(offsetHours)}:${padZero(offsetMinutes)}`
  }
  return isoDateTimeWithTimezone
}

export const formatIbanUK = (iban) => {
  return iban.substring(8, 10) + '-' + iban.substring(10, 12) + '-' + iban.substring(12, 14) + ' ' + iban.substring(14, 22)
}

export const formatIbanUKHidden = (iban) => {
  return 'XX-XX-' + iban.substring(12, 14) + ' XXXX' + iban.substring(18, 22)
}

export const formatIbanHidden = (iban) => {
  let len = iban.length
  let show = iban.substring(len - 4, len)
  return show.padStart(len, 'X')
}

export const formatIbanHiddenEnd = (iban) => {
  let len = iban.length
  let show = iban.substring(0, 9)
  return show.padEnd(len, 'X')
}

export const formatLettrage = (number) => {
  if (number !== '') {
    const corr = ['Z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '']
    const modulo = 26

    var line = ''
    var div = 0
    var reste = 0

    div = number

    do {
      // calcul du reste
      reste = div % modulo
      // calcul du total-reste divisé par le modulo
      div = (div - reste) / modulo
      if (reste === 0) div = div - 1
      // On préfixe la ligne par la lettre correspondante
      line = corr[reste] + line
    } while (div > 26)
    // Si le nombre > 0 alors on préfixe la ligne par la lettre correspondante
    if (div > 0) line = corr[div] + line

    return line
  } else {
    return number
  }
}

export const padZero = (value) => {
  return value.toString().padStart(2, '0')
}
